import moment from "moment";
import { License } from "../models/License";

export function getLicenses(): License[] {
  const userData = JSON.parse(localStorage.getItem('user'))
  return userData?.licenses ?? []
}

export function isExpired(license: License): boolean {
  const diffInDays = getDiffInDays(license)
  if (diffInDays > 0) {
    return false
  }
  return true
}

export function getDiffInDays(license: License) {
  const expiry = moment(license.expires_at, 'MM/DD/YYYY')
  return expiry.diff(moment(), 'days')
}

export function isStaff(licenses: License[]): boolean {
  const staffLicense = licenses.find((license: License) => license.platform === 'Staff' && isExpired(license) === false)
  if (staffLicense) {
    return true
  }
  return false
}

export function hasActiveLicense(licenses: License[]): boolean {
  if (licenses.find((license: License) => license.is_default === 'true' && isExpired(license) === false)) {
    return true
  }
  return false
}

export function isAuthorized() {
  const licenses = getLicenses()
  if (isStaff(licenses) || hasActiveLicense(licenses)) {
    return true
  }
  return false
}
